import { useAtom } from '@reatom/npm-react'

import type { Atom } from '@reatom/framework'

export const useOptionalAtom: {
  <T>(atom: Atom<T> | undefined): T | undefined
  <T>(atom: Atom<T> | undefined, fallback: T): T
} = <T>(atom: Atom<T> | undefined, fallback?: T) => {
  const [value] = useAtom((ctx) => (atom ? ctx.spy(atom) : undefined), [atom])
  return value ?? fallback
}
